<template>
    <label class="checkbox path"> 
        <input alt="toggle to delete projects without being prompted" type="checkbox" @click="checkIt" id="quitCheckBox">
        <svg viewBox="0 0 21 21">
            <path d="M5,10.75 L8.5,14.25 L19.4,2.3 C18.8333333,1.43333333 18.0333333,1 17,1 L4,1 C2.35,1 1,2.35 1,4 L1,17 C1,18.65 2.35,20 4,20 L17,20 C18.65,20 20,18.65 20,17 L20,7.99769186"></path>
        </svg>
    </label>

</template>

<script>
export default {
    data() {
        return {
        }
    },
    methods: {
        async checkIt() {
            let storeCheck =  await this.$store.state.isAsking
            let domCheck = document.getElementById("quitCheckBox").checked
            
            this.$store.commit('setIsAsking')
            console.log(`DOM: ${domCheck}`) 
            return domCheck = storeCheck
        }
    },
    mounted() {
        document.getElementById("quitCheckBox").checked = this.$store.state.uiStore.isAsking
    }
}
</script>

<style lang="stylus" scoped>

    .checkbox 
        --border: var(--text)
        --border-hover: var(--text)
        --border-active: var(--text)
        --tick: var(--brightest-panel)
        position: relative;
        
        input,svg 
            width: 4vmin
            height: 4vmin
            display: block;
    
        input 
            -webkit-appearance: none;
            -moz-appearance: none;
            position: relative;
            outline: none;
            background: var(--background);
            border: none;
            margin: 0;
            padding: 0;
            cursor: pointer;
            border-radius: 7px;
            transition: box-shadow .3s;
            box-shadow: inset 0 0 0 var(--s, 1px) var(--b, var(--border));
            &:hover 
                --s: 2px;
                --b: var(--border-hover);
            
            &:checked 
                --b: var(--border-active);
        
    
        svg 
            pointer-events: none;
            fill: none;
            stroke-width: 2px;
            stroke-linecap: round;
            stroke-linejoin: round;
            stroke: var(--stroke, var(--border-active));
            position: absolute;
            top: 0
            left: 0
            width: 4vmin
            height: 4vmin
            transform: scale(var(--scale, 1)) translateZ(0);
    
        &.path 
            input 
                &:checked 
                    --s: 2px;
                    transition-delay: .4s;
                    & + svg 
                        --a: 16.1 86.12;
                        --o: 102.22;
                    
                
            
            svg 
                stroke-dasharray: var(--a, 86.12);
                stroke-dashoffset: var(--o, 86.12);
                transition: stroke-dasharray .6s, stroke-dashoffset .6s;
        
    
    






</style>